import { Button, Input, makeStyles, tokens } from '@fluentui/react-components';
import {
  COMPACT_ACTION_SIZE,
  COMPACT_CONTROL_HEIGHT,
  COMPACT_CONTROL_RADIUS,
} from './controlStyles';

const useStyles = makeStyles({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    width: 'fit-content',
    flexShrink: 0,
    border: `1px solid ${tokens.colorNeutralStroke2}`,
    borderRadius: COMPACT_CONTROL_RADIUS,
    height: COMPACT_CONTROL_HEIGHT,
    boxSizing: 'border-box',
    padding: '0.125rem',
    gap: tokens.spacingHorizontalXXS,
    overflow: 'hidden',
    backgroundColor: tokens.colorNeutralBackground1,
  },
  button: {
    minWidth: COMPACT_ACTION_SIZE,
    height: COMPACT_ACTION_SIZE,
    borderRadius: COMPACT_CONTROL_RADIUS,
  },
  value: {
    height: COMPACT_ACTION_SIZE,
    width: '2.5rem',
    minWidth: '2.5rem',
    textAlign: 'center',
    border: '0',
    '& input': {
      textAlign: 'center',
      padding: '0',
    },
  },
});

export type QuantityStepperProps = {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  disabled?: boolean;
  label?: string;
};

export function QuantityStepper({
  value,
  onChange,
  min = 0,
  max,
  disabled = false,
  label = 'Quantity',
}: QuantityStepperProps) {
  const styles = useStyles();
  const decrement = () => onChange(Math.max(min, value - 1));
  const increment = () => onChange(max === undefined ? value + 1 : Math.min(max, value + 1));

  return (
    <div className={styles.root} aria-label={label}>
      <Button
        className={styles.button}
        appearance="primary"
        size="small"
        aria-label={`Decrease ${label.toLowerCase()}`}
        disabled={disabled || value <= min}
        onClick={decrement}
      >
        -
      </Button>
      <Input
        className={styles.value}
        appearance="underline"
        size="small"
        value={String(value)}
        aria-label={label}
        readOnly
      />
      <Button
        className={styles.button}
        appearance="primary"
        size="small"
        aria-label={`Increase ${label.toLowerCase()}`}
        disabled={disabled || (max !== undefined && value >= max)}
        onClick={increment}
      >
        +
      </Button>
    </div>
  );
}
